var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-surface-secondary w-100" },
    [
      _c("modal-masive", {
        attrs: { onmasive: _vm.onmasive, count: _vm.count_masive },
        on: {
          onclose: function ($event) {
            _vm.onmasive = false
          },
          onmasive: function ($event) {
            return _vm.MASIVE()
          },
        },
      }),
      _vm._v(" "),
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-3" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _vm._m(0),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c(
          "div",
          { staticClass: "container-fluid vstack gap-5" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column flex-md-row gap-3 justify-content-between",
              },
              [
                _c("div", { staticClass: "d-flex gap-3 row" }, [
                  _c("div", { staticClass: "col-md-4 px-0" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "input-group input-group-sm input-group-inline",
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("search", {
                          attrs: {
                            autofocus: "",
                            "item-text": "awb",
                            "item-value": "awb",
                            childplaceholder: "Seleccione o ingrese un AWB...",
                            endpoint: "/close/awbs",
                          },
                          model: {
                            value: _vm.awb,
                            callback: function ($$v) {
                              _vm.awb = $$v
                            },
                            expression: "awb",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-h px-3 btn-primary",
                        attrs: { type: "button", disabled: !_vm.awb },
                        on: {
                          click: function ($event) {
                            return _vm.FILTER()
                          },
                        },
                      },
                      [
                        _vm.loading == "filter"
                          ? _c(
                              "div",
                              {
                                staticClass: "spinner-border spinner-border-sm",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Loading..."),
                                ]),
                              ]
                            )
                          : _c("span", [_vm._v("Filtrar")]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-h px-3 btn-danger",
                        attrs: { type: "button", disabled: !_vm.awb },
                        on: {
                          click: function ($event) {
                            return _vm.CLEAR()
                          },
                        },
                      },
                      [_c("span", [_vm._v("Limpiar")])]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.scan == true
                    ? _c("div", { staticClass: "mr-0 ml-auto" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-h px-3 btn-success",
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.data.packages.length == 0 &&
                                _vm.data.hawbs.filter(function (e) {
                                  return e.packages.length > 0
                                }).length == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.MASIVE_VALIDATE()
                              },
                            },
                          },
                          [
                            _vm.loading == "masive"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "spinner-border spinner-border-sm",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Loading..."),
                                    ]),
                                  ]
                                )
                              : _c("span", [
                                  _c("i", {
                                    staticClass: "bi bi-arrow-clockwise",
                                  }),
                                  _vm._v(
                                    " Facturación masiva\n                            "
                                  ),
                                ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm.scan == false
              ? _c("div", { staticClass: "w-100 py-3" }, [
                  _vm.scan == false && _vm.loading == ""
                    ? _c(
                        "p",
                        { staticClass: "text-sm text-muted text-left mb-0" },
                        [
                          _vm._v(
                            "Seleccione o ingrese un AWB para empezar a escanear."
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _c("div", { staticClass: "card" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    (_vm.scan == true && _vm.data.packages.length > 0) ||
                    (_vm.scan == true && _vm.data.hawbs.length > 0)
                      ? _c("div", [
                          _c(
                            "form",
                            {
                              staticClass: "d-flex gap-3 row",
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.CHECK()
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-lg-11 col-sm-10 col-9 px-0",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "input-group input-group-inline",
                                    },
                                    [
                                      _vm._m(4),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.number,
                                            expression: "number",
                                          },
                                        ],
                                        ref: "number",
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          readonly:
                                            _vm.loading == "destination",
                                          placeholder: "Buscar...",
                                        },
                                        domProps: { value: _vm.number },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.number = $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn px-3 btn-primary",
                                    attrs: {
                                      type: "submit",
                                      disabled: !_vm.number,
                                    },
                                  },
                                  [
                                    _vm.loading == "destination"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "spinner-border spinner-border-sm",
                                            attrs: { role: "status" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [_vm._v("Loading...")]
                                            ),
                                          ]
                                        )
                                      : _c("span", [_vm._v("Buscar")]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _c(
                          "p",
                          {
                            staticClass: "text-sm text-muted text-center mb-0",
                          },
                          [_vm._v("No hay resultados.")]
                        ),
                  ]),
                ]),
            _vm._v(" "),
            _vm.data.packages.length > 0
              ? _c("table-scan", {
                  attrs: { data: _vm.data.packages, title: _vm.data.awb },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.data.hawbs, function (item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("table-scan", {
                    attrs: { data: item.packages, title: item.hawb },
                  }),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h1", { staticClass: "h4 ls-tight" }, [_vm._v("Escaneo")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _c("i", { staticClass: "bi bi-search" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center gap-3" }, [
      _c("div", { staticClass: "mb-1 d-flex gap-2 align-items-center" }, [
        _c("div", { staticClass: "cuadre-color border bg-white" }),
        _c("small", [_vm._v(": Sin escanear")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-1 d-flex gap-2 align-items-center" }, [
        _c("div", { staticClass: "cuadre-color yellow" }),
        _c("small", [_vm._v(": Escaneado")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-1 d-flex gap-2 align-items-center" }, [
        _c("div", { staticClass: "cuadre-color bg-secondary" }),
        _c("small", [_vm._v(": En proceso")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-1 d-flex gap-2 align-items-center" }, [
        _c("div", { staticClass: "cuadre-color bg-primary" }),
        _c("small", [_vm._v(": Facturación masiva")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Escaneo")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _vm._v("GV"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }